import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.center.room');
import { OnInit, OnDestroy, Input, ViewChild, ElementRef, HostListener, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { Rect, RemotePlayer, ChatMessage, SpeechBubble, STATUS_OPTIONS, getStatusColor, getStatusLabel } from "src/libs/portal/metaverse/types";
import { SOLUTION_CENTER_MAP_DATA, RESEARCH_CENTER_MAP_DATA, TILE_ROWS, TILE_COLS } from "src/libs/portal/metaverse/map-data";
import { GameRenderer } from "src/libs/portal/metaverse/game-renderer";
import { initSocketHandlers } from "src/libs/portal/metaverse/socket-handler";

@Component({
    selector: 'wiz-page-center-room',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.center.room/view.scss */
:host {
  display: block;
  height: 100%;
}

.webinar-strip-shell {
  position: absolute;
  top: 1rem;
  left: 50%;
  z-index: 22;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: calc(100vw - 2rem);
  transform: translateX(-50%);
}

.webinar-strip {
  display: flex;
  gap: 0.5rem;
  max-width: 912px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
}

.webinar-strip::-webkit-scrollbar {
  display: none;
}

.webinar-tile {
  position: relative;
  flex: 0 0 176px;
  width: 176px;
  height: 99px;
  overflow: hidden;
  scroll-snap-align: start;
  box-sizing: border-box;
  border: 2px solid rgba(255, 255, 255, 0.24);
  border-radius: 8px;
  background: #111827;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.32);
  transition: border-color 120ms ease, box-shadow 120ms ease;
}

.webinar-tile.is-speaking {
  border-color: #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.45), 0 12px 28px rgba(0, 0, 0, 0.32);
}

.webinar-video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #111827;
}

.webinar-video-mirror {
  transform: scaleX(-1);
}

.webinar-video-off {
  opacity: 0;
}

.webinar-video-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.72);
  background: linear-gradient(135deg, #1f2937, #0f766e);
  font-size: 1.75rem;
}

.webinar-name {
  position: absolute;
  left: 0.5rem;
  right: 2.25rem;
  bottom: 0.35rem;
  overflow: hidden;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.1;
  text-overflow: ellipsis;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.8);
  white-space: nowrap;
}

.webinar-mic-state {
  position: absolute;
  right: 0.45rem;
  bottom: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 999px;
  color: #fff;
  background: rgba(16, 185, 129, 0.92);
  font-size: 0.7rem;
}

.webinar-mic-state.is-off {
  background: rgba(239, 68, 68, 0.94);
}

.webinar-scroll-btn,
.webinar-control-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
  background: rgba(17, 24, 39, 0.82);
  backdrop-filter: blur(10px);
  transition: background 120ms ease, transform 120ms ease;
}

.webinar-scroll-btn {
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  font-size: 0.75rem;
}

.webinar-scroll-btn:hover,
.webinar-control-btn:hover {
  background: rgba(31, 41, 55, 0.94);
  transform: translateY(-1px);
}

.webinar-control-bar {
  position: absolute;
  left: 50%;
  bottom: 1.25rem;
  z-index: 22;
  display: flex;
  gap: 0.75rem;
  transform: translateX(-50%);
}

.webinar-control-btn {
  width: 3rem;
  height: 3rem;
  border-radius: 999px;
  font-size: 1rem;
}

.webinar-control-btn.is-off {
  background: rgba(185, 28, 28, 0.92);
}

.webinar-leave-btn {
  background: rgba(220, 38, 38, 0.92) !important;
}
.webinar-leave-btn:hover {
  background: rgb(185, 28, 28) !important;
}

.webinar-join-bar {
  position: absolute;
  left: 50%;
  bottom: 1.25rem;
  z-index: 22;
  transform: translateX(-50%);
}

.webinar-join-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 7.5rem;
  height: 2.75rem;
  justify-content: center;
  padding: 0 1.25rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  background: rgba(16, 185, 129, 0.88);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  transition: background 120ms ease, opacity 120ms ease, transform 120ms ease;
}
.webinar-join-btn:hover {
  background: rgba(5, 150, 105, 0.95);
  transform: translateY(-1px);
}
.webinar-join-btn:disabled, .webinar-join-btn.is-loading {
  cursor: not-allowed;
  opacity: 0.65;
  transform: none;
}

.webinar-tile-expanded {
  flex: 0 0 352px !important;
  width: 352px !important;
  height: 198px !important;
  z-index: 5;
}

@media (min-width: 768px) and (max-width: 1279px) {
  .webinar-strip {
    max-width: 544px;
  }
}
@media (max-width: 768px) {
  .minimap-container {
    transform: scale(0.75);
    transform-origin: top left;
    margin-bottom: -1.25rem;
  }
  .webinar-strip-shell {
    top: 0.75rem;
    max-width: calc(100vw - 1rem);
  }
  .webinar-strip {
    max-width: calc(100vw - 5rem);
  }
  .webinar-tile {
    flex-basis: calc((100vw - 5.5rem) / 2);
    width: calc((100vw - 5.5rem) / 2);
    min-width: 128px;
    height: 80px;
  }
  .webinar-scroll-btn {
    flex-basis: 1.75rem;
    width: 1.75rem;
    height: 1.75rem;
  }
  .webinar-control-bar {
    bottom: 5.25rem;
  }
  .webinar-join-bar {
    bottom: 5.25rem;
  }
  .webinar-control-btn {
    width: 2.75rem;
    height: 2.75rem;
  }
  .webinar-tile-expanded {
    flex-basis: calc(100vw - 5.5rem) !important;
    width: calc(100vw - 5.5rem) !important;
    height: 160px !important;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .left-panel-container {
    left: 2.5rem;
  }
}`],
})
export class PageCenterRoomComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() title: any;
    @ViewChild('gameCanvas', { static: true }) gameCanvasRef!: ElementRef<HTMLCanvasElement>;
    @ViewChild('spaceContainer', { static: true }) containerRef!: ElementRef<HTMLDivElement>;
    @ViewChild('onlinePanel') onlinePanelRef: any;
    @ViewChild('centerSwitcher') centerSwitcherRef: any;
    @ViewChild('sidemenuRef') sidemenuRef: any;
    @ViewChild('webinarStrip') webinarStripRef?: ElementRef<HTMLDivElement>;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    // 맵 설정
    public currentRoom: string = 'solution';
    public MAP_WIDTH = 2200;
    public MAP_HEIGHT = 1160;
    public mapImage: HTMLImageElement | null = null;
    public mapLoaded: boolean = false;
    private tileMap: number[][] = [];
    private GRID_SIZE = 40;
    private _destroyed = false;

    public isMobile: boolean = false;

    // 플레이어
    public playerX = 400;
    public playerY = 400;
    public playerSize = 28;
    public playerSpeed = 4;
    public playerColor = '#4F8EF7';
    public mySid: string = '';
    public userId: string = '';
    public myRole: string = 'user';

    // 다른 플레이어들
    public remotePlayers: { [sid: string]: RemotePlayer } = {};
    // 전체 room 접속자 (귓속말/접속자 목록용)
    public allRemotePlayers: { [sid: string]: any } = {};
    public onlineCount: number = 1;

    // 카메라
    public cameraX = 0;
    public cameraY = 0;

    // 미니맵 공유 상태 (참조 객체로 매 프레임 최신 값 제공)
    public minimapState = { playerX: 0, playerY: 0, cameraX: 0, cameraY: 0 };

    // 키 입력
    public keys: { [key: string]: boolean } = {};

    // 오브젝트 (충돌체)
    public objects: Rect[] = [];

    // 게임 루프
    private animFrameId: number = 0;
    private canvasCtx!: CanvasRenderingContext2D;
    private renderer: GameRenderer = new GameRenderer(28);
    private _lastFrameTime: number = 0;

    // 소켓
    public socket: any = null;
    public lastSyncX = 0;
    public lastSyncY = 0;
    private syncInterval: any = null;

    // 닉네임
    public nickname: string = '사용자';
    public myRealName: string = '';
    public myDepartment: string = '';
    public myTitle: string = '';
    public chatRoom: string = 'research';

    // 채팅
    public chatMessages: ChatMessage[] = [];
    public speechBubbles: Map<string, SpeechBubble> = new Map();
    public BUBBLE_DURATION = 5000;
    public joinTime: string = '';

    // 상태
    public statusOptions = STATUS_OPTIONS;
    public myStatus: string = 'in';
    public showStatusMenu: boolean = false;
    public intranetStatus: string = '';
    public statusConfirmTarget: string = '';

    // 컨텍스트 메뉴
    public showContextMenu: boolean = false;
    public contextMenuX: number = 0;
    public contextMenuY: number = 0;
    public contextTargetIsMe: boolean = false;
    private contextTargetSid: string = '';

    // 모달
    public modalOpen: boolean = false;
    public modalMode: string = 'info';
    public modalTitle: string = '';
    public modalPlayerData: any = null;
    public modalRecipientName: string = '';
    public modalRecipientLocked: boolean = true;

    // 귓속말
    public whisperTarget: any = null;
    // 쪽지
    public noteToast: any = null;
    private noteToastTimeout: any = null;
    public incomingNoteData: any = null;
    public receivedNotes: Array<{ from: string, message: string, time: Date, read: boolean }> = [];

    public get unreadNoteCount(): number {
        return this.receivedNotes.filter(n => !n.read).length;
    }
    // 로딩
    public isLoading: boolean = true;
    public showLoadingOverlay: boolean = true;
    public loadingProgress: number = 0;
    public loadingStage: string = '맵 로딩 중...';
    public sessionReplaced: boolean = false;
    private _targetProgress: number = 0;
    private _loadingTimer: any = null;

    // 찌르기
    public pokeAnimations: Map<string, { startTime: number, fromX: number, fromY: number }> = new Map();
    public POKE_DURATION = 1500;
    public pokeToast: string = '';
    private pokeToastTimeout: any = null;

    // 입력 중 표시
    public typingPlayers: { [sid: string]: string } = {};
    public typingTimeouts: { [sid: string]: any } = {};

    // 채팅창 카메라 오프셋
    private isChatOpen: boolean = false;
    private cameraOffsetX: number = 0;
    private targetCameraOffsetX: number = 0;
    private CHAT_PANEL_WIDTH = 360;

    // 자리비움 자동 감지
    private _idleCheckInterval: any = null;
    private _lastActivityTime: number = Date.now();
    private _isAutoAway: boolean = false;
    private _isManualAway: boolean = false;
    private _preAwayStatus: string = 'in';
    private readonly IDLE_TIMEOUT_MS = 60000; // 1분
    private _idleActivityHandler: (() => void) | null = null;
    private _idleDetector: any = null;

    // 점프
    public isJumping: boolean = false;
    public jumpStartTime: number = 0;
    public JUMP_DURATION = 400;
    public JUMP_HEIGHT = 24;

    // 인트라넷 상태 연동
    private intranetSyncInterval: any = null;
    private INTRANET_SYNC_INTERVAL_MS = 60000;

    // 포탈 호버
    public hoveringPortal: boolean = false;
    public centerSwitchTarget: string = '';
    private _portalModalShown: boolean = true;

    // 웨비나
    public webinarPromptOpen: boolean = false;
    public webinarPendingRoom: string = '';
    public webinarActiveRoom: string = '';
    public webinarError: string = '';
    public webinarJoining: boolean = false;
    public webinarMicEnabled: boolean = true;
    public webinarCameraEnabled: boolean = true;
    public webinarParticipants: any[] = [];
    public expandedWebinarSid: string = '';
    private webinarLocalStream: MediaStream | null = null;
    private webinarPeers: { [sid: string]: RTCPeerConnection } = {};
    private webinarRemoteStreams: { [sid: string]: MediaStream } = {};
    private webinarRemoteMeta: { [sid: string]: any } = {};
    private _webinarPromptDismissedArea: string = '';
    private readonly WEBINAR_RTC_CONFIG: RTCConfiguration = {
        iceServers: [
            { urls: 'stun:stun.l.google.com:19302' },
            { urls: 'stun:stun1.l.google.com:19302' },
            { urls: 'stun:stun2.l.google.com:19302' },
            { urls: 'stun:stun3.l.google.com:19302' },
            { urls: 'stun:stun4.l.google.com:19302' },
        ],
        iceCandidatePoolSize: 10,
    };
    private webinarIceRetryTimers: { [sid: string]: any } = {};
    private readonly WEBINAR_ICE_RETRY_DELAY = 5000;
    private webinarPendingIceCandidates: { [sid: string]: any[] } = {};
    private webinarAudioAnalysers: { [sid: string]: { analyser: AnalyserNode, ctx: AudioContext, source: MediaElementAudioSourceNode | MediaStreamAudioSourceNode, rafId: number } } = {};

    // 캐릭터 외형
    public myShape: string = 'circle';

    public get allPlayers(): any {
        return this._cachedAllPlayers;
    }

    private _cachedAllPlayers: any = {};
    private _cachedRoomPlayers: Array<{ sid: string, nickname: string, color?: string }> = [];

    /** remotePlayers/allRemotePlayers/myData 변경 시 호출 필요 */
    private rebuildPlayerCaches() {
        const all: any = {};
        if (this.mySid) {
            all[this.mySid] = { sid: this.mySid, userId: this.userId, nickname: this.nickname, color: this.playerColor, x: this.playerX, y: this.playerY, status: this.myStatus };
        }
        for (const sid of Object.keys(this.allRemotePlayers)) {
            const p = this.allRemotePlayers[sid];
            all[sid] = { sid: p.sid, userId: p.userId || '', nickname: p.nickname, color: p.color, x: p.x, y: p.y, status: p.status, room: p.room };
        }
        this._cachedAllPlayers = all;
        this._cachedRoomPlayers = Object.keys(this.allRemotePlayers).map(sid => ({
            sid,
            nickname: this.allRemotePlayers[sid].nickname,
            color: this.allRemotePlayers[sid].color,
        }));
    }

    public get roomPlayers(): Array<{ sid: string, nickname: string, color?: string }> {
        return this._cachedRoomPlayers;
    }

    // ===== 라이프사이클 =====

    public async ngOnInit() {
        await this.service.init();

        // room 파라미터 판별
        const room = WizRoute.segment?.room || '';
        if (room !== 'solution' && room !== 'research') {
            this.service.href('/center/solution');
            return;
        }
        this.currentRoom = room;

        this.isMobile = window.innerWidth <= 768;

        if (!this.service.auth.session || !this.service.auth.session.id) {
            this.service.href('/login');
            return;
        }

        this.userId = this.service.auth.session.id || '';
        this.myRole = this.service.auth.session.role || 'user';

        this.initObjects();

        if (this.service.auth?.session?.name) {
            this.nickname = this.service.auth.session.name;
            this.myRealName = this.service.auth.session.name;
        } else if (this.service.auth?.session?.id) {
            this.nickname = this.service.auth.session.id;
            this.myRealName = this.service.auth.session.id;
        } else {
            this.nickname = '사용자' + Math.floor(Math.random() * 1000);
            this.myRealName = this.nickname;
        }

        const savedNickname = localStorage.getItem('space_nickname');
        if (savedNickname) {
            this.nickname = savedNickname;
        }

        if (this.service.auth?.session) {
            this.myDepartment = this.service.auth.session.department || '';
            this.myTitle = this.service.auth.session.title || '';
        }

        // department 기반 chatRoom 결정
        this.chatRoom = (this.myDepartment.startsWith('AI솔루션센터') || this.myDepartment === '대표') ? 'solution' : 'research';

        this.isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (this.isMobile) this.CHAT_PANEL_WIDTH = 280;

        this.connectSocket();
        this.startIntranetSync();
        this.startIdleDetection();
        await this.service.render();
    }

    public ngAfterViewInit() {
        this.setupCanvas();
        this.gameLoop();
    }

    public ngOnDestroy() {
        this._destroyed = true;
        if (this.animFrameId) cancelAnimationFrame(this.animFrameId);
        if (this.syncInterval) clearInterval(this.syncInterval);
        if (this.intranetSyncInterval) clearInterval(this.intranetSyncInterval);
        if (this.noteToastTimeout) clearTimeout(this.noteToastTimeout);
        if (this.pokeToastTimeout) clearTimeout(this.pokeToastTimeout);
        if (this._socketTimeout) clearTimeout(this._socketTimeout);
        if (this._loadingTimer) clearInterval(this._loadingTimer);
        if (this._idleCheckInterval) clearInterval(this._idleCheckInterval);
        this.stopIdleDetection();
        this.leaveWebinar('destroy');
        for (const key of Object.keys(this.typingTimeouts)) {
            clearTimeout(this.typingTimeouts[key]);
        }
        if (this.mapImage) {
            this.mapImage.onload = null;
            this.mapImage.onerror = null;
            this.mapImage = null;
        }
        if (this.socket) this.socket.disconnect();
    }

    // ===== 채팅/귓속말 =====

    public reloadPage() {
        window.location.reload();
    }

    private emitChat(text: string, scope: 'center' | 'global') {
        if (!text || !this.socket?.connected) return;
        if (text.length > 150) text = text.slice(0, 150);
        this.socket.emit(scope === 'center' ? 'chat' : 'global_chat', { message: text });
        delete this.typingPlayers[this.mySid];
        this.speechBubbles.set(this.mySid, {
            message: text,
            expireAt: Date.now() + this.BUBBLE_DURATION,
            scope,
        });
        this.chatMessages = [...this.chatMessages, {
            sid: this.mySid,
            userId: this.userId,
            nickname: this.nickname,
            message: text,
            color: this.playerColor,
            timestamp: Date.now(),
            scope,
        }];
    }

    public sendChatMessage(text: string) { this.emitChat(text, 'center'); }
    public sendGlobalChatMessage(text: string) { this.emitChat(text, 'global'); }

    public sendWhisperMessage(event: { targetNickname: string, message: string }) {
        if (!this.socket?.connected) return;
        let targetSid = '';
        for (const sid of Object.keys(this.allRemotePlayers)) {
            if (this.allRemotePlayers[sid].nickname === event.targetNickname) { targetSid = sid; break; }
        }
        if (!targetSid) return;
        const message = event.message.length > 150 ? event.message.slice(0, 150) : event.message;
        this.socket.emit("whisper", { target_sid: targetSid, message });
    }

    // ===== 캔버스 좌클릭: 센터 전환 타일 감지 =====

    private isPortalTile(row: number, col: number): boolean {
        if (this.currentRoom === 'solution') {
            return row >= 13 && row <= 16 && col === 54;
        } else if (this.currentRoom === 'research') {
            return row === 28 && col >= 39 && col <= 42;
        }
        return false;
    }

    private isCalendarTile(row: number, col: number): boolean {
        if (this.currentRoom !== 'solution') return false;
        return row >= 11 && row <= 12 && col >= 18 && col <= 22;
    }

    public hoveringCalendar: boolean = false;

    public onCanvasMouseMove(event: MouseEvent) {
        const canvas = this.gameCanvasRef.nativeElement;
        const rect = canvas.getBoundingClientRect();
        const worldX = event.clientX - rect.left + this.cameraX;
        const worldY = event.clientY - rect.top + this.cameraY;
        const col = Math.floor(worldX / this.GRID_SIZE);
        const row = Math.floor(worldY / this.GRID_SIZE);
        const onPortal = this.isPortalTile(row, col);
        const onCalendar = this.isCalendarTile(row, col);
        const onPlayer = this.findPlayerAtPosition(worldX, worldY);
        canvas.style.cursor = (onPortal || onCalendar || onPlayer) ? 'pointer' : 'default';
        this.hoveringPortal = onPortal;
        this.hoveringCalendar = onCalendar;
    }

    public onCanvasClick(event: MouseEvent) {
        if (this.modalOpen || this.showContextMenu) return;
        const canvas = this.gameCanvasRef.nativeElement;
        const rect = canvas.getBoundingClientRect();
        const worldX = event.clientX - rect.left + this.cameraX;
        const worldY = event.clientY - rect.top + this.cameraY;

        const col = Math.floor(worldX / this.GRID_SIZE);
        const row = Math.floor(worldY / this.GRID_SIZE);

        // 캘린더 타일 클릭 (Col 18~22, Row 11~12)
        if (this.isCalendarTile(row, col)) {
            window.open('https://outlook.office365.com/calendar/view/month', '_blank', 'noopener,noreferrer');
            return;
        }

        // 캐릭터 좌클릭 → 컨텍스트 메뉴
        const target = this.findPlayerAtPosition(worldX, worldY);
        if (target) {
            this.contextTargetSid = target.sid;
            this.contextTargetIsMe = (target.sid === this.mySid);
            this.contextMenuX = event.clientX;
            this.contextMenuY = event.clientY;
            this.showContextMenu = true;
            event.stopPropagation();
            this.service.render();
            return;
        }

        if (this.currentRoom === 'solution') {
            if (row >= 13 && row <= 16 && col === 54) {
                this.openCenterSwitchModal('research');
            }
        } else if (this.currentRoom === 'research') {
            if (row === 28 && col >= 39 && col <= 42) {
                this.openCenterSwitchModal('solution');
            }
        }
    } 

    private checkPortalEntry() {
        if (this.isLoading) return;
        const col = Math.floor(this.playerX / this.GRID_SIZE);
        const row = Math.floor(this.playerY / this.GRID_SIZE);
        const onPortal = this.isPortalTile(row, col);

        if (onPortal && !this._portalModalShown && !this.modalOpen) {
            this._portalModalShown = true;
            if (this.currentRoom === 'solution') {
                this.openCenterSwitchModal('research');
            } else if (this.currentRoom === 'research') {
                this.openCenterSwitchModal('solution');
            }
        } else if (!onPortal) {
            this._portalModalShown = false;
        }
    }

    public async openCenterSwitchModal(target: string) {
        this.centerSwitchTarget = target;
        this.modalTitle = '센터 이동';
        this.modalMode = 'center_switch';
        this.modalOpen = true;
        await this.service.render();
    }

    public async onCenterSwitchConfirm(target: string) {
        this.modalOpen = false;
        window.location.href = `/center/${target}`;
    } 

    // ===== 컨텍스트 메뉴 =====

    public onCanvasContextMenu(event: MouseEvent) {
        event.preventDefault();
        if (this.modalOpen || this.showContextMenu) return;
        const canvas = this.gameCanvasRef.nativeElement;
        const rect = canvas.getBoundingClientRect();
        const clickX = event.clientX - rect.left + this.cameraX;
        const clickY = event.clientY - rect.top + this.cameraY;

        const target = this.findPlayerAtPosition(clickX, clickY);
        if (!target) { this.showContextMenu = false; this.service.render(); return; }

        this.contextTargetSid = target.sid;
        this.contextTargetIsMe = (target.sid === this.mySid);
        this.contextMenuX = event.clientX;
        this.contextMenuY = event.clientY;
        this.showContextMenu = true;
        this.service.render();
    }

    private findPlayerAtPosition(x: number, y: number): any {
        const half = this.playerSize / 2 + 8;
        if (Math.abs(x - this.playerX) < half && Math.abs(y - this.playerY) < half) {
            return { sid: this.mySid, nickname: this.nickname, color: this.playerColor, status: this.myStatus };
        }
        for (const sid of Object.keys(this.remotePlayers)) {
            const p = this.remotePlayers[sid];
            if (Math.abs(x - p.x) < half && Math.abs(y - p.y) < half) return p;
        }
        return null;
    }

    public async onCtxInfo() {
        const player = this.contextTargetSid === this.mySid
            ? { sid: this.mySid, nickname: this.nickname, color: this.playerColor, status: this.myStatus, department: this.myDepartment, title: this.myTitle, realName: this.myRealName }
            : (this.remotePlayers[this.contextTargetSid] || this.allRemotePlayers[this.contextTargetSid]);
        if (!player) { this.showContextMenu = false; await this.service.render(); return; }
        this.modalPlayerData = player;
        this.modalTitle = '정보보기';
        this.modalMode = 'info';
        this.modalOpen = true;
        this.showContextMenu = false;
        await this.service.render();
    }

    public async onCtxNote() {
        const player = this.remotePlayers[this.contextTargetSid] || this.allRemotePlayers[this.contextTargetSid];
        if (!player) { this.showContextMenu = false; await this.service.render(); return; }
        this.modalRecipientName = player.nickname;
        this.modalRecipientLocked = true;
        this.modalTitle = '쪽지 보내기';
        this.modalMode = 'message';
        this.modalOpen = true;
        this.showContextMenu = false;
        await this.service.render();
    }

    public async onCtxWhisper() {
        const player = this.remotePlayers[this.contextTargetSid] || this.allRemotePlayers[this.contextTargetSid];
        if (!player) { this.showContextMenu = false; await this.service.render(); return; }
        this.whisperTarget = { ...player };
        this.showContextMenu = false;
        await this.service.render();
    }

    public async onWhisperTargetRequest() {
        this.modalTitle = '귓속말 대상 선택';
        this.modalMode = 'whisper_target';
        this.modalOpen = true;
        await this.service.render();
    }

    public async onWhisperTargetSelected(player: any) {
        this.whisperTarget = { ...player };
        await this.service.render();
    }

    public async onCtxPoke() {
        if (!this.socket?.connected) return;
        this.socket.emit("poke", { target_sid: this.contextTargetSid });
        this.showContextMenu = false;
        await this.service.render();
    }

    public async onCtxMyInfo() {
        this.showContextMenu = false;
        await this.onSideMenuMyInfo();
    }

    public async onMyInfoSave(event: any) {
        if (!this.socket?.connected) return;
        if (event.nickname && event.nickname !== this.nickname) {
            this.nickname = event.nickname;
            localStorage.setItem('space_nickname', event.nickname);
            this.socket.emit("nickname_change", { nickname: event.nickname });
        }
        if (event.color && event.color !== this.playerColor) {
            this.playerColor = event.color;
            this.socket.emit("color_change", { color: event.color });
        }
        if (event.shape && event.shape !== this.myShape) {
            this.myShape = event.shape;
            this.socket.emit("appearance_change", {
                shape: this.myShape,
            });
        }
        this.modalOpen = false;
        await this.service.render();
    }

    public async closeModal() {
        if (this.modalMode === 'webinar_join') {
            this._webinarPromptDismissedArea = this.webinarPendingRoom || this.getCurrentWebinarRoom();
            this.webinarPromptOpen = false;
            this.webinarPendingRoom = '';
            this.webinarError = '';
            this.webinarJoining = false;
        }
        this.modalOpen = false;
        this.incomingNoteData = null;
        await this.service.render();
    }

    // ===== 웨비나 =====

    private getCurrentWebinarRoom(): string {
        const col = Math.floor(this.playerX / this.GRID_SIZE);
        const row = Math.floor(this.playerY / this.GRID_SIZE);
        if (this.currentRoom === 'solution' && col >= 29 && col <= 40 && row >= 1 && row <= 9) {
            return 'solution_meeting';
        }
        if (this.currentRoom === 'research' && col >= 46 && col <= 53 && row >= 11 && row <= 27) {
            return 'research_meeting';
        }
        return '';
    }

    public webinarRoomName(room?: string): string {
        const target = room || this.webinarPendingRoom || this.webinarActiveRoom;
        if (target === 'solution_meeting') return 'AI 솔루션 센터 회의실';
        if (target === 'research_meeting') return 'AI 연구센터 회의실';
        return '회의실';
    }

    private checkWebinarAreaEntry() {
        if (this.isLoading) return;
        const room = this.getCurrentWebinarRoom();

        if (!room) {
            this._webinarPromptDismissedArea = '';
            if (this.webinarPromptOpen) {
                this.webinarPromptOpen = false;
                this.webinarPendingRoom = '';
                this.webinarError = '';
                if (this.modalMode === 'webinar_join') {
                    this.modalOpen = false;
                    this.modalMode = 'info';
                }
                this.service.render();
            }
            if (this.webinarActiveRoom) {
                this.leaveWebinar('left_area');
            }
            return;
        }

        if (this.webinarActiveRoom && this.webinarActiveRoom !== room) {
            this.leaveWebinar('room_changed');
        }

        if (!this.webinarActiveRoom && !this.webinarPromptOpen && !this.modalOpen && !this.showContextMenu && this._webinarPromptDismissedArea !== room) {
            this.webinarPendingRoom = room;
            this.webinarPromptOpen = true;
            this.webinarError = '';
            this.modalTitle = '화상 회의';
            this.modalMode = 'webinar_join';
            this.modalOpen = true;
            this.service.render();
        }
    }

    public async acceptWebinar(event: { stream?: MediaStream, error?: string }) {
        const room = this.webinarPendingRoom || this.getCurrentWebinarRoom();
        if (!room) return;

        if (event.error || !event.stream) {
            this.webinarJoining = false;
            if (event.error === 'unsupported') {
                this.webinarError = '이 브라우저에서는 웹캠과 마이크를 사용할 수 없습니다.';
            } else {
                this.webinarError = '웹캠과 마이크 권한이 필요합니다.';
            }
            await this.service.render();
            return;
        }

        const stream = event.stream;
        this.webinarJoining = true;
        this.webinarError = '';

        if (this.getCurrentWebinarRoom() !== room) {
            stream.getTracks().forEach(track => track.stop());
            this.webinarJoining = false;
            await this.dismissWebinarPrompt();
            return;
        }

        this.webinarLocalStream = stream;
        this.webinarActiveRoom = room;
        this.webinarPendingRoom = '';
        this.webinarPromptOpen = false;
        this.modalOpen = false;
        this.modalMode = 'info';
        this.webinarMicEnabled = true;
        this.webinarCameraEnabled = true;
        this.webinarJoining = false;
        this.syncWebinarParticipants();
        if (this.socket?.connected) {
            this.socket.emit('webinar_join', {
                room,
                audioEnabled: this.webinarMicEnabled,
                videoEnabled: this.webinarCameraEnabled,
            });
        }
        await this.service.render();
    }

    public async dismissWebinarPrompt() {
        this._webinarPromptDismissedArea = this.webinarPendingRoom || this.getCurrentWebinarRoom();
        this.webinarPromptOpen = false;
        this.webinarPendingRoom = '';
        this.webinarError = '';
        this.webinarJoining = false;
        if (this.modalMode === 'webinar_join') {
            this.modalOpen = false;
            this.modalMode = 'info';
        }
        await this.service.render();
    }

    public async toggleWebinarMic() {
        this.webinarMicEnabled = !this.webinarMicEnabled;
        this.webinarLocalStream?.getAudioTracks().forEach(track => track.enabled = this.webinarMicEnabled);
        this.emitWebinarMediaState();
        this.syncWebinarParticipants();
        await this.service.render();
    }

    public async toggleWebinarCamera() {
        this.webinarCameraEnabled = !this.webinarCameraEnabled;
        this.webinarLocalStream?.getVideoTracks().forEach(track => track.enabled = this.webinarCameraEnabled);
        this.emitWebinarMediaState();
        this.syncWebinarParticipants();
        await this.service.render();
    }

    public async leaveWebinarManual() {
        this.leaveWebinar('manual');
        this._webinarPromptDismissedArea = this.getCurrentWebinarRoom();
        await this.service.render();
    }

    public async openWebinarJoinModal() {
        const room = this.getCurrentWebinarRoom();
        if (!room || this.webinarActiveRoom || this.webinarPromptOpen) return;
        this.webinarPendingRoom = room;
        this.webinarPromptOpen = true;
        this.webinarError = '';
        this.modalTitle = '화상 회의';
        this.modalMode = 'webinar_join';
        this.modalOpen = true;
        this._webinarPromptDismissedArea = '';
        await this.service.render();
    }

    public async toggleWebinarExpand(sid: string) {
        this.expandedWebinarSid = this.expandedWebinarSid === sid ? '' : sid;
        await this.service.render();
    }

    public trackBySid(_index: number, item: any): string {
        return item.sid;
    }

    public get showWebinarScrollButtons(): boolean {
        return this.webinarParticipants.length > this.getWebinarVisibleLimit();
    }

    public scrollWebinarStrip(direction: number) {
        const el = this.webinarStripRef?.nativeElement;
        if (!el) return;
        el.scrollBy({ left: direction * Math.max(220, el.clientWidth * 0.8), behavior: 'smooth' });
    }

    private getWebinarVisibleLimit(): number {
        const width = window.innerWidth;
        if (width < 768) return 2;
        if (width < 1280) return 3;
        return 5;
    }

    private emitWebinarMediaState() {
        if (!this.socket?.connected || !this.webinarActiveRoom) return;
        this.socket.emit('webinar_media_state', {
            audioEnabled: this.webinarMicEnabled,
            videoEnabled: this.webinarCameraEnabled,
        });
    }

    public async onWebinarJoined(data: any) {
        if (!this.webinarLocalStream) return;
        this.webinarActiveRoom = data.room || this.webinarActiveRoom;
        this.webinarPromptOpen = false;
        this.webinarPendingRoom = '';
        this.webinarError = '';
        if (this.modalMode === 'webinar_join') {
            this.modalOpen = false;
            this.modalMode = 'info';
        }
        this.syncWebinarParticipants();
        for (const participant of (data.participants || [])) {
            if (participant.sid && participant.sid !== this.mySid) {
                this.webinarRemoteMeta[participant.sid] = participant;
                if (this.shouldCreateWebinarOffer(participant.sid)) {
                    await this.createWebinarOffer(participant.sid);
                }
            }
        }
        this.syncWebinarParticipants();
        await this.service.render();
    }

    public async onWebinarJoinDenied(data: any) {
        const message = data?.reason === 'out_of_area' ? '회의실 영역 안에서만 참여할 수 있습니다.' : '화상 회의에 참여할 수 없습니다.';
        this.leaveWebinar('join_denied', false);
        this.webinarError = message;
        this.webinarPendingRoom = this.getCurrentWebinarRoom();
        this.webinarPromptOpen = !!this.webinarPendingRoom;
        if (this.webinarPromptOpen) {
            this.modalTitle = '화상 회의';
            this.modalMode = 'webinar_join';
            this.modalOpen = true;
        }
        this._webinarPromptDismissedArea = this.webinarPendingRoom;
        await this.service.render();
    }

    public async onWebinarParticipantJoined(data: any) {
        if (!this.webinarActiveRoom || data.sid === this.mySid) return;
        this.webinarRemoteMeta[data.sid] = data;
        this.syncWebinarParticipants();
        await this.service.render();
        if (this.webinarLocalStream && this.shouldCreateWebinarOffer(data.sid)) {
            await this.createWebinarOffer(data.sid);
        }
    }

    public async onWebinarParticipantLeft(data: any) {
        if (!data?.sid) return;
        this.closeWebinarPeer(data.sid);
        delete this.webinarRemoteStreams[data.sid];
        delete this.webinarRemoteMeta[data.sid];
        this.syncWebinarParticipants();
        await this.service.render();
    }

    public async onWebinarParticipants(data: any) {
        if (!this.webinarActiveRoom || data?.room !== this.webinarActiveRoom) return;
        const seen: { [sid: string]: boolean } = {};
        for (const participant of (data.participants || [])) {
            if (!participant?.sid) continue;
            seen[participant.sid] = true;
            if (participant.sid === this.mySid) continue;
            this.webinarRemoteMeta[participant.sid] = {
                ...this.webinarRemoteMeta[participant.sid],
                ...participant,
            };
        }
        for (const sid of Object.keys(this.webinarRemoteMeta)) {
            if (!seen[sid]) {
                this.closeWebinarPeer(sid);
                delete this.webinarRemoteStreams[sid];
                delete this.webinarRemoteMeta[sid];
            }
        }
        this.syncWebinarParticipants();
        await this.service.render();
        // Initiate connections to new participants
        if (this.webinarLocalStream) {
            for (const sid of Object.keys(this.webinarRemoteMeta)) {
                if (!this.webinarPeers[sid] && this.shouldCreateWebinarOffer(sid)) {
                    await this.createWebinarOffer(sid);
                }
            }
        }
    }

    public async onWebinarMediaState(data: any) {
        if (!data?.sid) return;
        if (data.sid === this.mySid) {
            this.webinarMicEnabled = data.audioEnabled !== false;
            this.webinarCameraEnabled = data.videoEnabled !== false;
        } else {
            const meta = this.webinarRemoteMeta[data.sid] || { sid: data.sid, nickname: this.allRemotePlayers[data.sid]?.nickname || '참여자' };
            meta.audioEnabled = data.audioEnabled !== false;
            meta.videoEnabled = data.videoEnabled !== false;
            this.webinarRemoteMeta[data.sid] = meta;
        }
        this.syncWebinarParticipants();
        await this.service.render();
    }

    public async onWebinarForceLeave(_data: any) {
        this.leaveWebinar('force_leave', false);
        await this.service.render();
    }

    public async onWebinarSignal(data: any) {
        if (!this.webinarActiveRoom || !this.webinarLocalStream) return;
        const fromSid = data?.from_sid;
        const signal = data?.signal;
        if (!fromSid || !signal || fromSid === this.mySid) return;

        const pc = this.ensureWebinarPeer(fromSid);
        if (!pc) return;

        try {
            if (signal.type === 'offer') {
                await pc.setRemoteDescription(new RTCSessionDescription(signal.description));
                await this.drainWebinarPendingIce(fromSid, pc);
                const answer = await pc.createAnswer();
                await pc.setLocalDescription(answer);
                this.sendWebinarSignal(fromSid, { type: 'answer', description: pc.localDescription });
            } else if (signal.type === 'answer') {
                await pc.setRemoteDescription(new RTCSessionDescription(signal.description));
                await this.drainWebinarPendingIce(fromSid, pc);
            } else if (signal.type === 'ice' && signal.candidate) {
                if (!pc.remoteDescription?.type) {
                    if (!this.webinarPendingIceCandidates[fromSid]) this.webinarPendingIceCandidates[fromSid] = [];
                    this.webinarPendingIceCandidates[fromSid].push(signal.candidate);
                } else {
                    await pc.addIceCandidate(new RTCIceCandidate(signal.candidate));
                }
            }
        } catch (e) {
            console.error('webinar signal failed:', e);
        }
    }

    private async drainWebinarPendingIce(sid: string, pc: RTCPeerConnection) {
        const candidates = this.webinarPendingIceCandidates[sid];
        if (!candidates || candidates.length === 0) return;
        delete this.webinarPendingIceCandidates[sid];
        for (const candidate of candidates) {
            try {
                await pc.addIceCandidate(new RTCIceCandidate(candidate));
            } catch (e) {
                console.warn('[webinar] Failed to add buffered ICE candidate:', e);
            }
        }
    }

    private shouldCreateWebinarOffer(targetSid: string): boolean {
        return !!this.mySid && !!targetSid && this.mySid < targetSid;
    }

    private async createWebinarOffer(targetSid: string) {
        const pc = this.ensureWebinarPeer(targetSid);
        if (!pc) return;
        try {
            const offer = await pc.createOffer();
            await pc.setLocalDescription(offer);
            this.sendWebinarSignal(targetSid, { type: 'offer', description: pc.localDescription });
        } catch (e) {
            console.error('webinar offer failed:', e);
        }
    }

    private ensureWebinarPeer(targetSid: string): RTCPeerConnection | null {
        if (!this.webinarLocalStream || !targetSid) return null;
        if (this.webinarPeers[targetSid]) return this.webinarPeers[targetSid];

        const pc = new RTCPeerConnection(this.WEBINAR_RTC_CONFIG);
        this.webinarPeers[targetSid] = pc;
        this.webinarLocalStream.getTracks().forEach(track => {
            if (this.webinarLocalStream) pc.addTrack(track, this.webinarLocalStream);
        });
        pc.onicecandidate = (event) => {
            if (event.candidate) {
                this.sendWebinarSignal(targetSid, { type: 'ice', candidate: event.candidate });
            }
        };
        pc.ontrack = (event) => {
            console.log(`[webinar] ontrack from ${targetSid}, tracks:`, event.streams?.[0]?.getTracks().length);
            const stream = event.streams?.[0] || this.webinarRemoteStreams[targetSid] || new MediaStream();
            if (!event.streams?.[0] && event.track) stream.addTrack(event.track);
            this.webinarRemoteStreams[targetSid] = stream;
            const meta = this.webinarRemoteMeta[targetSid] || { sid: targetSid, nickname: this.allRemotePlayers[targetSid]?.nickname || '참여자' };
            this.webinarRemoteMeta[targetSid] = meta;
            this.syncWebinarParticipants();
            this.service.render();
            // Ensure video elements play after DOM update
            setTimeout(() => this.ensureWebinarVideosPlay(), 200);
        };
        pc.oniceconnectionstatechange = () => {
            console.log(`[webinar] ICE state ${targetSid}: ${pc.iceConnectionState}`);
            if (pc.iceConnectionState === 'connected' || pc.iceConnectionState === 'completed') {
                this.clearWebinarIceRetry(targetSid);
            } else if (pc.iceConnectionState === 'failed') {
                this.handleWebinarIceFailed(targetSid, pc);
            } else if (pc.iceConnectionState === 'disconnected') {
                this.scheduleWebinarIceRetry(targetSid, pc);
            }
        };
        pc.onconnectionstatechange = () => {
            console.log(`[webinar] Connection state ${targetSid}: ${pc.connectionState}`);
            if (pc.connectionState === 'failed' || pc.connectionState === 'closed') {
                this.clearWebinarIceRetry(targetSid);
                this.closeWebinarPeer(targetSid);
                // Retry connection after delay
                if (this.webinarActiveRoom && this.webinarLocalStream && this.webinarRemoteMeta[targetSid]) {
                    setTimeout(() => {
                        if (this.webinarActiveRoom && this.webinarLocalStream && this.webinarRemoteMeta[targetSid] && !this.webinarPeers[targetSid]) {
                            console.log(`[webinar] Retrying connection to ${targetSid}`);
                            if (this.shouldCreateWebinarOffer(targetSid)) {
                                this.createWebinarOffer(targetSid);
                            }
                        }
                    }, this.WEBINAR_ICE_RETRY_DELAY);
                }
                this.syncWebinarParticipants();
                this.service.render();
            }
        };
        return pc;
    }

    private handleWebinarIceFailed(targetSid: string, pc: RTCPeerConnection) {
        console.log(`[webinar] ICE failed for ${targetSid}, attempting restart`);
        this.clearWebinarIceRetry(targetSid);
        try {
            pc.restartIce();
            if (this.shouldCreateWebinarOffer(targetSid)) {
                pc.createOffer({ iceRestart: true }).then(offer => {
                    return pc.setLocalDescription(offer);
                }).then(() => {
                    this.sendWebinarSignal(targetSid, { type: 'offer', description: pc.localDescription });
                }).catch(e => console.error('[webinar] ICE restart offer failed:', e));
            }
        } catch (e) {
            console.error('[webinar] ICE restart failed:', e);
        }
    }

    private scheduleWebinarIceRetry(targetSid: string, pc: RTCPeerConnection) {
        this.clearWebinarIceRetry(targetSid);
        this.webinarIceRetryTimers[targetSid] = setTimeout(() => {
            if (pc.iceConnectionState === 'disconnected' || pc.iceConnectionState === 'failed') {
                this.handleWebinarIceFailed(targetSid, pc);
            }
        }, 3000);
    }

    private clearWebinarIceRetry(targetSid: string) {
        if (this.webinarIceRetryTimers[targetSid]) {
            clearTimeout(this.webinarIceRetryTimers[targetSid]);
            delete this.webinarIceRetryTimers[targetSid];
        }
    }

    private ensureWebinarVideosPlay() {
        const videos = document.querySelectorAll('.webinar-video') as NodeListOf<HTMLVideoElement>;
        videos.forEach(video => {
            if (video.srcObject && video.paused) {
                video.play().catch(() => { });
            }
        });
    }

    private sendWebinarSignal(targetSid: string, signal: any) {
        if (!this.socket?.connected || !this.webinarActiveRoom) return;
        this.socket.emit('webinar_signal', { target_sid: targetSid, signal });
    }

    private closeWebinarPeer(sid: string) {
        const pc = this.webinarPeers[sid];
        if (!pc) return;
        this.clearWebinarIceRetry(sid);
        pc.onicecandidate = null;
        pc.ontrack = null;
        pc.oniceconnectionstatechange = null;
        pc.onconnectionstatechange = null;
        pc.close();
        delete this.webinarPeers[sid];
    }

    private syncWebinarParticipants() {
        const list: any[] = [];
        if (this.webinarActiveRoom && this.webinarLocalStream) {
            list.push({
                sid: this.mySid,
                nickname: this.nickname,
                stream: this.webinarLocalStream,
                audioEnabled: this.webinarMicEnabled,
                videoEnabled: this.webinarCameraEnabled,
                isLocal: true,
            });
        }
        for (const sid of Object.keys(this.webinarRemoteMeta)) {
            const meta = this.webinarRemoteMeta[sid];
            list.push({
                sid,
                nickname: meta.nickname || this.allRemotePlayers[sid]?.nickname || '참여자',
                stream: this.webinarRemoteStreams[sid] || null,
                audioEnabled: meta.audioEnabled !== false,
                videoEnabled: meta.videoEnabled !== false,
                isLocal: false,
            });
        }
        this.webinarParticipants = list;
    }

    private leaveWebinar(reason: string = 'left_area', notifyServer: boolean = true) {
        const hadActiveRoom = !!this.webinarActiveRoom;
        if (notifyServer && hadActiveRoom && this.socket?.connected) {
            this.socket.emit('webinar_leave', { room: this.webinarActiveRoom, reason });
        }
        for (const sid of Object.keys(this.webinarPeers)) {
            this.closeWebinarPeer(sid);
        }
        for (const sid of Object.keys(this.webinarIceRetryTimers)) {
            this.clearWebinarIceRetry(sid);
        }
        this.webinarLocalStream?.getTracks().forEach(track => track.stop());
        this.webinarLocalStream = null;
        this.webinarRemoteStreams = {};
        this.webinarRemoteMeta = {};
        this.webinarPendingIceCandidates = {};
        this.webinarParticipants = [];
        this.webinarActiveRoom = '';
        this.webinarMicEnabled = true;
        this.webinarCameraEnabled = true;
        if (!this._destroyed && hadActiveRoom) {
            this.service.render();
        }
    }

    public async onCtxCloseMenu() {
        this.showContextMenu = false;
        await this.service.render();
    }

    public showPokeToast(message: string) {
        this.pokeToast = message;
        if (this.pokeToastTimeout) clearTimeout(this.pokeToastTimeout);
        this.pokeToastTimeout = setTimeout(() => {
            this.pokeToast = '';
            this.service.render();
        }, 3000);
        this.service.render();
    }

    // ===== 사이드 메뉴/상태/쪽지 =====

    public async onSideMenuStatusChange(status: string) {
        if (this.intranetStatus && status !== this.intranetStatus) {
            this.statusConfirmTarget = status;
            this.modalMode = 'status_confirm';
            this.modalTitle = '상태 변경 확인';
            this.modalOpen = true;
            await this.service.render();
            return;
        }
        await this.changeStatus(status);
    }

    public async onStatusConfirm() {
        if (this.statusConfirmTarget) {
            await this.changeStatus(this.statusConfirmTarget);
            this.statusConfirmTarget = '';
        }
    }

    public async openColorFromMenu() {
        this.modalMode = 'colorpicker';
        this.modalTitle = '색상 변경';
        this.modalOpen = true;
        await this.service.render();
    }

    public async onSideMenuMyInfo() {
        this.modalPlayerData = {
            sid: this.mySid, nickname: this.nickname, color: this.playerColor,
            status: this.myStatus, department: this.myDepartment, title: this.myTitle, realName: this.myRealName,
            shape: this.myShape,
        };
        this.modalTitle = '내 정보';
        this.modalMode = 'myinfo';
        this.modalOpen = true;
        await this.service.render();
    }

    public async onSideMenuLogout() {
        this.modalTitle = '로그아웃';
        this.modalMode = 'logout_confirm';
        this.modalOpen = true;
        await this.service.render();
    }

    public async onGoToSeat() {
        let seat: any = null;
        try {
            const res = await wiz.call("seat_get");
            if (res.code === 200 && res.data?.seat) {
                seat = res.data.seat;
            }
        } catch (e) { }
        if (!seat) return;

        if (seat.room === this.currentRoom) {
            // 같은 센터: 즉시 텔레포트
            this.playerX = seat.col * this.GRID_SIZE + this.GRID_SIZE / 2;
            this.playerY = seat.row * this.GRID_SIZE + this.GRID_SIZE / 2;
            this.cameraX = this.playerX - this.gameCanvasRef.nativeElement.width / 2;
            this.cameraY = this.playerY - this.gameCanvasRef.nativeElement.height / 2;
            this.lastSyncX = this.playerX;
            this.lastSyncY = this.playerY;
            if (this.socket?.connected) {
                this.socket.emit("move", { x: Math.round(this.playerX), y: Math.round(this.playerY) });
            }
            await this.service.render();
        } else {
            // 다른 센터: 로딩 표시 후 이동
            sessionStorage.setItem('seatSpawn', 'true');
            window.location.href = `/center/${seat.room}`;
        }
    }

    public async onLogoutConfirm() {
        this.modalOpen = false;
        try {
            await wiz.call("logout");
        } catch (e) { }
        this.service.href('/login');
    }

    public async openNoteDetail(note: any) {
        this.incomingNoteData = { nickname: note.sender_nickname || note.from, message: note.message, color: note.color || '#4F8EF7' };
        this.modalMode = 'incoming_note';
        this.modalTitle = '받은 쪽지';
        this.modalOpen = true;
        if (note.id && !note.is_read && this.sidemenuRef?.markNoteRead) {
            this.sidemenuRef.markNoteRead(note.id);
        }
        await this.service.render();
    }

    public async onNoteToastClick() {
        const latestNote = this.receivedNotes[0];
        if (latestNote) {
            this.incomingNoteData = { nickname: latestNote.nickname || latestNote.from, message: latestNote.message, color: latestNote.color || '#4F8EF7' };
        }
        this.noteToast = null;
        if (this.noteToastTimeout) clearTimeout(this.noteToastTimeout);
        this.modalMode = 'incoming_note';
        this.modalTitle = '받은 쪽지';
        this.modalOpen = true;
        await this.service.render();
    }

    public async deleteNote(index: number) {
        this.receivedNotes.splice(index, 1);
        await this.service.render();
    }

    public async onNoteSend(event: any) {
        if (!this.socket?.connected) return;
        if (typeof event === 'string') {
            this.socket.emit("note", { target_sid: this.contextTargetSid, message: event });
        } else if (event.targetSid && event.message) {
            this.socket.emit("note", { target_sid: event.targetSid, message: event.message });
        }
        this.modalOpen = false;
        await this.service.render();
    }

    public async openNoteComposeModal() {
        this.modalRecipientName = '';
        this.modalRecipientLocked = false;
        this.modalTitle = '쪽지 보내기';
        this.modalMode = 'message';
        this.modalOpen = true;
        await this.service.render();
    }

    public async onNoteReply(event: any) {
        const fromNickname = typeof event === 'string' ? event : (event?.nickname || '');
        // allRemotePlayers에서 먼저 검색하여 센터가 다른 사용자도 찾기
        for (const sid of Object.keys(this.allRemotePlayers)) {
            if (this.allRemotePlayers[sid].nickname === fromNickname) { this.contextTargetSid = sid; break; }
        }
        if (!this.contextTargetSid) {
            for (const sid of Object.keys(this.remotePlayers)) {
                if (this.remotePlayers[sid].nickname === fromNickname) { this.contextTargetSid = sid; break; }
            }
        }
        this.modalMode = 'message';
        this.modalTitle = '쪽지 보내기';
        this.modalRecipientName = fromNickname;
        this.modalRecipientLocked = true;
        await this.service.render();
    }

    public async onColorSelect(color: string) {
        if (!this.socket?.connected) return;
        this.playerColor = color;
        this.socket.emit("color_change", { color });
        this.modalOpen = false;
        await this.service.render();
    }

    public onChatToggle(isOpen: boolean) {
        this.isChatOpen = isOpen;
        this.targetCameraOffsetX = isOpen ? (this.CHAT_PANEL_WIDTH / 2) : 0;
    }

    public onTypingStart() {
        if (this.socket?.connected) this.socket.emit("typing_start", {});
        this.typingPlayers[this.mySid] = this.nickname;
    }

    public onTypingStop() {
        if (this.socket?.connected) this.socket.emit("typing_stop", {});
        delete this.typingPlayers[this.mySid];
    }

    public async changeStatus(status: string) {
        if (status === 'away') {
            this._isManualAway = true;
        } else {
            this._isManualAway = false;
            this._isAutoAway = false;
        }
        this.myStatus = status;
        this.showStatusMenu = false;
        if (this.socket?.connected) this.socket.emit("status_change", { status });
        await this.service.render();
    }

    // ===== 인트라넷 상태 연동 =====

    private startIntranetSync() {
        this.syncIntranetStatus();
        this.intranetSyncInterval = setInterval(() => {
            this.syncIntranetStatus();
        }, this.INTRANET_SYNC_INTERVAL_MS);
    }

    private async syncIntranetStatus() {
        // 수동 away 또는 자동 away 상태일 때는 인트라넷 동기화 스킵
        if (this._isManualAway || this._isAutoAway) return;
        try {
            const res = await wiz.call("intranet_status");
            if (res.code === 200 && res.data) {
                const mapped = res.data.mapped_status || res.data.raw_status || '';
                if (mapped) this.intranetStatus = mapped;
                if (mapped && mapped !== this.myStatus && !this._isManualAway && !this._isAutoAway) {
                    this.myStatus = mapped;
                    if (this.socket?.connected) this.socket.emit("status_change", { status: mapped });
                    await this.service.render();
                }
            }
        } catch (_) { }
    }

    public async toggleStatusMenu() {
        this.showStatusMenu = !this.showStatusMenu;
        await this.service.render();
    }



    public getOnlinePlayerList(): any[] {
        const list: any[] = [];
        if (this.mySid) list.push({ sid: this.mySid, nickname: this.nickname, color: this.playerColor, status: this.myStatus, department: this.myDepartment, realName: this.myRealName, title: this.myTitle });
        for (const sid of Object.keys(this.allRemotePlayers)) {
            const p = this.allRemotePlayers[sid];
            list.push({ sid: p.sid, nickname: p.nickname, color: p.color, status: p.status, department: p.department, realName: p.realName, title: p.title });
        }
        return list;
    }

    public async onOnlinePlayerClick(player: any) {
        if (player.sid === this.mySid) {
            await this.onSideMenuMyInfo();
            return;
        }
        this.modalPlayerData = player;
        this.modalTitle = '정보보기';
        this.modalMode = 'info';
        this.modalOpen = true;
        await this.service.render();
    }

    public async closeStatusMenu() {
        if (this.showStatusMenu) { this.showStatusMenu = false; await this.service.render(); }
    }

    public getStatusColor(status: string): string { return getStatusColor(status); }
    public getStatusLabel(status: string): string { return getStatusLabel(status); }

    // ===== 드롭다운 상호 배타 =====

    public async onCloseOtherDropdowns() {
        if (this.onlinePanelRef?.closePanel) {
            await this.onlinePanelRef.closePanel();
        }
    }

    public async onCloseOtherDropdownsFromOnline() {
        if (this.centerSwitcherRef?.forceClose) {
            await this.centerSwitcherRef.forceClose();
        }
    }

    // ===== 캐릭터 컴포넌트 이벤트 =====

    public onKeysChange(keys: { [key: string]: boolean }) {
        this.keys = keys;
    }

    public onJoystickDirection(keys: { [key: string]: boolean }) {
        this.keys = keys;
    }

    @HostListener('window:resize')
    onResize() { this.setupCanvas(); }

    @HostListener('window:click', ['$event'])
    onWindowClick(event: MouseEvent) {
        if (this.modalOpen) return;
        const target = event.target as HTMLElement;
        if (this.showStatusMenu && !target.closest('.status-selector')) this.closeStatusMenu();
    }

    private performJump() {
        if (this.isJumping) return;
        this.isJumping = true;
        this.jumpStartTime = Date.now();
        if (this.socket?.connected) {
            this.socket.emit("jump", {});
        }
    }

    // ===== 소켓 =====

    private _socketTimeout: any = null;

    private connectSocket() {
        if (this.socket) return;
        this.socket = wiz.socket();
        initSocketHandlers(this);

        this._socketTimeout = setTimeout(() => {
            if (this.isLoading && !this.sessionReplaced) {
                console.error('Socket initialization timeout — forcing load complete');
                this._targetProgress = 99;
                this.setLoadingProgress(100, '완료!');
            }
        }, 15000);
    }

    public startSyncInterval() {
        this.syncInterval = setInterval(() => {
            const dx = Math.abs(this.playerX - this.lastSyncX);
            const dy = Math.abs(this.playerY - this.lastSyncY);
            if (dx > 1 || dy > 1) {
                this.lastSyncX = this.playerX;
                this.lastSyncY = this.playerY;
                if (this.socket?.connected) {
                    this.socket.emit("move", { x: Math.round(this.playerX), y: Math.round(this.playerY) });
                }
            }
        }, 50);
    }

    public updateOnlineCount() {
        this.onlineCount = Object.keys(this.allRemotePlayers).length + 1;
    }

    public async loadChatHistory() {
        try {
            const res = await wiz.call("chat_history", { dump: 50, room: this.chatRoom });
            if (res.code === 200 && res.data?.rows) {
                const dbMessages: ChatMessage[] = res.data.rows.reverse().map((row: any) => ({
                    sid: row.user_id,
                    userId: row.user_id,
                    nickname: row.nickname,
                    message: row.message,
                    color: row.color || '#4F8EF7',
                    timestamp: new Date(row.created).getTime(),
                    type: row.type || 'normal',
                    scope: row.scope || 'center',
                    noUnread: true,
                }));
                this.chatMessages = [...dbMessages, ...this.chatMessages];
                await this.service.render();
            }
        } catch (e) {
            console.error("Failed to load chat history:", e);
        }
    }

    public setLoadingProgress(target: number, stage?: string) {
        if (target <= this._targetProgress) return;
        if (stage) this.loadingStage = stage;
        this._targetProgress = target;
        if (this._targetProgress >= 100) {
            if (this._loadingTimer) { clearInterval(this._loadingTimer); this._loadingTimer = null; }
            this.loadingProgress = 100;
            this.loadingStage = '완료!';
            this.isLoading = false;
            this.service.render();
            requestAnimationFrame(() => {
                this.showLoadingOverlay = false;
                this.service.render();
            });
            return;
        }
        if (this._loadingTimer) return;
        this._loadingTimer = setInterval(() => {
            if (this.loadingProgress < this._targetProgress) {
                const remain = this._targetProgress - this.loadingProgress;
                const step = Math.max(1, Math.ceil(remain * 0.15));
                this.loadingProgress = Math.min(this.loadingProgress + step, this._targetProgress);
                this.service.render();
            }
            if (this.loadingProgress >= this._targetProgress) {
                clearInterval(this._loadingTimer);
                this._loadingTimer = null;
            }
        }, 30);
    }

    // ===== Canvas/맵 =====

    private setupCanvas() {
        const canvas = this.gameCanvasRef.nativeElement;
        const container = this.containerRef.nativeElement;
        canvas.width = container.clientWidth;
        canvas.height = container.clientHeight;
        this.canvasCtx = canvas.getContext('2d')!;
    }

    private initObjects() {
        this.objects = [];
        const mapData = this.currentRoom === 'research' ? RESEARCH_CENTER_MAP_DATA : SOLUTION_CENTER_MAP_DATA;
        this.tileMap = mapData.map(row => row.split('').map(Number));

        for (let row = 0; row < TILE_ROWS; row++) {
            for (let col = 0; col < TILE_COLS; col++) {
                const tile = this.tileMap[row]?.[col];
                if (tile && tile > 0) {
                    this.objects.push({
                        x: col * this.GRID_SIZE,
                        y: row * this.GRID_SIZE,
                        w: this.GRID_SIZE,
                        h: this.GRID_SIZE,
                        color: tile === 1 ? '#5C6370' : '#A0845E',
                        type: tile === 1 ? 'wall' : 'furniture',
                    });
                }
            }
        }

        this.mapLoaded = false;
        this.renderer.invalidateMapCache();
        const mapImageName = this.currentRoom === 'research' ? 'research_center_map' : 'solution_center_map';
        const mapSrc = `/assets/images/${mapImageName}.png`;
        this.setLoadingProgress(10, '맵 로딩 중...');
        this.loadMapImage(mapSrc, 0);
    }

    private loadMapImage(src: string, attempt: number) {
        if (this._destroyed) return;
        const MAX_RETRIES = 3;
        const img = new Image();
        img.onload = () => {
            if (this._destroyed) return;
            this.mapImage = img;
            this.mapLoaded = true;
            this.renderer.cacheMapImage(img);
            this.setLoadingProgress(50, '소켓 연결 중...');
        };
        img.onerror = () => {
            if (this._destroyed) return;
            if (attempt < MAX_RETRIES) {
                setTimeout(() => {
                    this.loadMapImage(src.split('?')[0] + '?_r=' + (attempt + 1), attempt + 1);
                }, 1000);
            } else {
                console.error('Map image failed to load after retries:', src);
                this.mapImage = null;
                this.mapLoaded = true;
                this.setLoadingProgress(50, '소켓 연결 중...');
            }
        };
        img.src = src;
    }

    // ===== 자리비움 자동 감지 =====

    private startIdleDetection() {
        // IdleDetector API 지원 시 우선 사용 (OS 레벨 idle 감지)
        if ('IdleDetector' in window) {
            this.tryIdleDetectorAPI();
        } else {
            this.startIdleDetectionFallback();
        }
    }

    private async tryIdleDetectorAPI() {
        try {
            const IdleDetectorClass = (window as any).IdleDetector;
            const permission = await IdleDetectorClass.requestPermission();
            if (permission === 'granted') {
                const detector = new IdleDetectorClass();
                detector.addEventListener('change', () => {
                    const { userState, screenState } = detector;
                    if ((userState === 'idle' || screenState === 'locked') && !this._isAutoAway && !this._isManualAway && this.myStatus !== 'out') {
                        this._preAwayStatus = this.myStatus;
                        this._isAutoAway = true;
                        this.myStatus = 'away';
                        if (this.socket?.connected) this.socket.emit("status_change", { status: 'away' });
                        this.service.render();
                    } else if (userState === 'active' && screenState === 'unlocked') {
                        if (this._isAutoAway && !this._isManualAway) {
                            this._isAutoAway = false;
                            this.myStatus = this._preAwayStatus;
                            if (this.socket?.connected) this.socket.emit("status_change", { status: this._preAwayStatus });
                            this.service.render();
                        }
                    }
                });
                await detector.start({ threshold: this.IDLE_TIMEOUT_MS });
                this._idleDetector = detector;
                return;
            }
        } catch (_) { }
        // Permission 거부 또는 에러 시 fallback
        this.startIdleDetectionFallback();
    }

    private startIdleDetectionFallback() {
        this._lastActivityTime = Date.now();
        this._idleActivityHandler = () => { this.onUserActivity(); };
        document.addEventListener('mousemove', this._idleActivityHandler);
        document.addEventListener('keydown', this._idleActivityHandler);
        document.addEventListener('mousedown', this._idleActivityHandler);
        document.addEventListener('touchstart', this._idleActivityHandler);

        this._visibilityHandler = () => {
            if (document.visibilityState === 'visible') {
                this.onUserActivity();
            }
        };
        document.addEventListener('visibilitychange', this._visibilityHandler);

        this._idleCheckInterval = setInterval(() => {
            const elapsed = Date.now() - this._lastActivityTime;
            const isHidden = document.visibilityState === 'hidden';
            const timeout = isHidden ? Math.min(this.IDLE_TIMEOUT_MS, 15000) : this.IDLE_TIMEOUT_MS;
            if (elapsed >= timeout && !this._isAutoAway && !this._isManualAway && this.myStatus !== 'out') {
                this._preAwayStatus = this.myStatus;
                this._isAutoAway = true;
                this.myStatus = 'away';
                if (this.socket?.connected) this.socket.emit("status_change", { status: 'away' });
                this.service.render();
            }
        }, 10000);
    }

    private _visibilityHandler: (() => void) | null = null;

    private stopIdleDetection() {
        if (this._idleDetector) {
            this._idleDetector.stop();
            this._idleDetector = null;
        }
        if (this._idleActivityHandler) {
            document.removeEventListener('mousemove', this._idleActivityHandler);
            document.removeEventListener('keydown', this._idleActivityHandler);
            document.removeEventListener('mousedown', this._idleActivityHandler);
            document.removeEventListener('touchstart', this._idleActivityHandler);
            this._idleActivityHandler = null;
        }
        if (this._visibilityHandler) {
            document.removeEventListener('visibilitychange', this._visibilityHandler);
            this._visibilityHandler = null;
        }
    }

    private onUserActivity() {
        this._lastActivityTime = Date.now();
        if (this._isAutoAway && !this._isManualAway) {
            this._isAutoAway = false;
            this.myStatus = this._preAwayStatus;
            if (this.socket?.connected) this.socket.emit("status_change", { status: this._preAwayStatus });
            this.service.render();
        }
    }

    // ===== 게임 로직 =====

    private updatePlayer() {
        let dx = 0;
        let dy = 0;
        if (this.keys['up']) dy -= this.playerSpeed;
        if (this.keys['down']) dy += this.playerSpeed;
        if (this.keys['left']) dx -= this.playerSpeed;
        if (this.keys['right']) dx += this.playerSpeed;

        if (dx !== 0 && dy !== 0) {
            const factor = 1 / Math.sqrt(2);
            dx *= factor;
            dy *= factor;
        }

        const newX = this.playerX + dx;
        if (!this.checkCollision(newX, this.playerY)) this.playerX = newX;
        const newY = this.playerY + dy;
        if (!this.checkCollision(this.playerX, newY)) this.playerY = newY;

        const half = this.playerSize / 2;
        this.playerX = Math.max(half, Math.min(this.MAP_WIDTH - half, this.playerX));
        this.playerY = Math.max(half, Math.min(this.MAP_HEIGHT - half, this.playerY));
    }

    private updateRemotePlayers(dt: number) {
        // delta-time 기반 lerp (프레임 속도 무관한 일정 보간)
        const t = 1 - Math.pow(0.00001, dt);
        for (const sid in this.remotePlayers) {
            const p = this.remotePlayers[sid];
            const dx = p.targetX - p.x;
            const dy = p.targetY - p.y;
            if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) {
                p.x = p.targetX;
                p.y = p.targetY;
            } else {
                p.x += dx * t;
                p.y += dy * t;
            }
        }
    }

    private checkCollision(px: number, py: number): boolean {
        // 타일맵 직접 조회 (O(1)) — 기존 objects 배열 순회(O(n)) 대신
        const half = this.playerSize / 2;
        const gs = this.GRID_SIZE;
        const minCol = Math.floor((px - half) / gs);
        const maxCol = Math.floor((px + half - 0.01) / gs);
        const minRow = Math.floor((py - half) / gs);
        const maxRow = Math.floor((py + half - 0.01) / gs);

        for (let row = minRow; row <= maxRow; row++) {
            for (let col = minCol; col <= maxCol; col++) {
                const tile = this.tileMap[row]?.[col];
                if (tile === undefined || tile > 0) return true;
            }
        }
        return false;
    }

    private updateCamera(dt: number) {
        const canvas = this.gameCanvasRef.nativeElement;
        const offsetT = 1 - Math.pow(0.00001, dt * 0.55);
        this.cameraOffsetX += (this.targetCameraOffsetX - this.cameraOffsetX) * offsetT;

        const targetCamX = this.playerX - canvas.width / 2 + this.cameraOffsetX;
        const targetCamY = this.playerY - canvas.height / 2;

        // delta-time 기반 카메라 lerp (snap threshold 적용)
        const camT = 1 - Math.pow(0.00001, dt);
        const camDx = targetCamX - this.cameraX;
        const camDy = targetCamY - this.cameraY;
        this.cameraX = Math.abs(camDx) < 0.5 ? targetCamX : this.cameraX + camDx * camT;
        this.cameraY = Math.abs(camDy) < 0.5 ? targetCamY : this.cameraY + camDy * camT;

        // 미니맵 공유 상태 갱신 (매 프레임)
        this.minimapState.playerX = this.playerX;
        this.minimapState.playerY = this.playerY;
        this.minimapState.cameraX = this.cameraX;
        this.minimapState.cameraY = this.cameraY;
    }

    // ===== 렌더링 =====

    private renderCanvas() {
        this.renderer.renderScene(this.canvasCtx, this.gameCanvasRef.nativeElement, this);
    }

    // 첫 프레임 렌더 완료 추적
    private _firstFrameRendered: boolean = false;

    // ===== 게임 루프 =====

    private gameLoop = () => {
        const now = performance.now();
        const dt = this._lastFrameTime ? Math.min((now - this._lastFrameTime) / 1000, 0.05) : 0.016;
        this._lastFrameTime = now;

        if (!this.isLoading) {
            try {
                this.updatePlayer();
                this.checkPortalEntry();
                this.checkWebinarAreaEntry();
                this.updateRemotePlayers(dt);
                this.updateCamera(dt);
                this.renderCanvas();
                if (!this._firstFrameRendered && this.mapLoaded) {
                    this._firstFrameRendered = true;
                    this.setLoadingProgress(100, '완료!');
                }
            } catch (e) {
                console.error('gameLoop error:', e);
            }
        } else if (this._targetProgress >= 90 && this.mapLoaded) {
            // 로딩 중이지만 맵이 준비되면 즉시 로딩 해제
            this.setLoadingProgress(100, '완료!');
        }
        this.animFrameId = requestAnimationFrame(this.gameLoop);
    }
}

export default PageCenterRoomComponent;